/**
 * Strip the URL from browser-native "Failed to fetch (url)" TypeErrors.
 * Chrome/Safari append the request hostname to the error message, which
 * causes Meticulous false positives when replaying across environments.
 */
export function sanitizeErrorMessage(message) {
    if (typeof message !== 'string') return message
    // Only strip the trailing "(url)" that some browsers append to "Failed to fetch".
    // Handles both bare "Failed to fetch (url)" and "TypeError: Failed to fetch (url)".
    return message.replace(/^((?:TypeError:\s+)?Failed to fetch)\s*\([^)]+\)\s*$/i, '$1').trim()
}

export function useServerError() {
    function getMessage(err) {
        try {
            const errObject = JSON.parse(err.message)

            if (errObject.message) return errObject.message

            return errObject
        } catch {
            return sanitizeErrorMessage(err.message || err)
        }
    }

    return {
        getMessage,
    }
}
